import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SELECT_PUBLISH_TERMS_SERVICE = 'PUBLISH_TERMS :: SELECT_SERVICE';

export type TSelectPublishTermsAction = IReduxAction<typeof SELECT_PUBLISH_TERMS_SERVICE, string>;

export const selectPublishTermsService = actionGenerator<typeof SELECT_PUBLISH_TERMS_SERVICE, string>(
  SELECT_PUBLISH_TERMS_SERVICE,
);
